export const Crown = ({
  width = '20',
  height = '20',
}: {
  width?: string;
  height?: string;
  fill?: string;
  backgroundFill?: string | null;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.63421 2.72352C9.67018 2.65819 9.72303 2.60371 9.78723 2.56577C9.85143 2.52783 9.92464 2.50781 9.99921 2.50781C10.0738 2.50781 10.147 2.52783 10.2112 2.56577C10.2754 2.60371 10.3282 2.65819 10.3642 2.72352L12.8242 7.39352C12.8829 7.50165 12.9648 7.59546 13.064 7.6682C13.1632 7.74094 13.2773 7.79081 13.398 7.81423C13.5188 7.83765 13.6433 7.83404 13.7625 7.80366C13.8817 7.77328 13.9927 7.71688 14.0875 7.63852L17.6517 4.58518C17.7201 4.52953 17.8044 4.49703 17.8925 4.49235C17.9806 4.48767 18.0679 4.51105 18.1418 4.55914C18.2157 4.60722 18.2725 4.67752 18.3039 4.75993C18.3354 4.84233 18.3398 4.93258 18.3167 5.01768L15.955 13.556C15.9068 13.7307 15.803 13.885 15.6592 13.9954C15.5155 14.1057 15.3396 14.1662 15.1584 14.1677H4.84088C4.65949 14.1664 4.48347 14.106 4.33954 13.9956C4.19561 13.8852 4.09163 13.7309 4.04338 13.556L1.68255 5.01852C1.65942 4.93341 1.6639 4.84316 1.69533 4.76076C1.72676 4.67836 1.78353 4.60805 1.85746 4.55997C1.9314 4.51189 2.01868 4.4885 2.10675 4.49318C2.19482 4.49786 2.27913 4.53037 2.34755 4.58602L5.91088 7.63935C6.00571 7.71772 6.11672 7.77412 6.23593 7.8045C6.35515 7.83488 6.47961 7.83849 6.60038 7.81507C6.72115 7.79164 6.83524 7.74177 6.93446 7.66903C7.03367 7.59629 7.11555 7.50249 7.17421 7.39435L9.63421 2.72352Z"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.16602 17.5H15.8327"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
